import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "inline-flex flex-col" }
const _hoisted_2 = { class: "flex items-center" }
const _hoisted_3 = { class: "block font-semibold" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("   ")
const _hoisted_5 = {
  key: 0,
  class: "block text-neutral-400 text-sm"
}

import PolygonIcon from "@/components/icons/PolygonIcon.vue";
import { useCurrency } from "@/composables/useCurrency";


export default /*#__PURE__*/_defineComponent({
  __name: 'AppPrice',
  props: ["price", "hideFiat", "digits"],
  setup(__props) {

const props = __props

const { maticToUsd } = useCurrency();



const round = (price: number | string) =>
    Number(price).toFixed(props.digits || 2);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(round(__props.price)), 1),
      _hoisted_4,
      _createVNode(PolygonIcon, { class: "w-2 h-4 block" })
    ]),
    (!__props.hideFiat)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_unref(maticToUsd)(__props.price, __props.digits)) + " $", 1))
      : _createCommentVNode("", true)
  ]))
}
}

})